import BrowserRouter from '@fuse/core/BrowserRouter';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import { SnackbarProvider } from 'notistack';
import { useSelector } from 'react-redux';
import createCache, { Options } from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { selectCurrentLanguageDirection } from 'app/store/i18nSlice';
import { selectUser, selectUserRole } from 'app/store/user/userSlice';
import themeLayouts from 'app/theme-layouts/themeLayouts';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import settingsConfig from 'app/configs/settingsConfig';
import { useAppDispatch, useAppSelector } from 'app/store';
import withAppProviders from './withAppProviders';
import { AuthProvider } from './main/auth/AuthContext';
import { useLayoutEffect } from 'react';
import { getPeevaSettings } from './store/fuse/peevaSettings';


// import axios from 'axios';
/**
 * Axios HTTP Request defaults
 */
// axios.defaults.baseURL = "";
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';

const emotionCacheOptions = {
	rtl: {
		key: 'muirtl',
		stylisPlugins: [],
		insertionPoint: document.getElementById('emotion-insertion-point')
	},
	ltr: {
		key: 'muiltr',
		stylisPlugins: [],
		insertionPoint: document.getElementById('emotion-insertion-point')
	}
};

/**
 * The main App component.
 */
function App() {
	const dispatch = useAppDispatch();
	const userRole = useAppSelector(selectUserRole);

	const user = useAppSelector(selectUser);

	const langDirection = useSelector(selectCurrentLanguageDirection);

	const mainTheme = useSelector(selectMainTheme);
	const loginRedirectUrl = user?.data?.settings?.loginRedirectUrl || settingsConfig.loginRedirectUrl;

	useLayoutEffect(() => {
		dispatch(getPeevaSettings());
	}, [dispatch]);

	return (
		<CacheProvider value={createCache(emotionCacheOptions[langDirection] as Options)}>
			<FuseTheme
				theme={mainTheme}
				direction={langDirection}
			>
				<AuthProvider>
					<BrowserRouter>
						<FuseAuthorization
							userRole={userRole}
							loginRedirectUrl={loginRedirectUrl}
						>
							<SnackbarProvider
								maxSnack={5}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right'
								}}
								classes={{
									containerRoot: 'bottom-0 right-0 mb-52 md:mb-68 mr-8 lg:mr-80 z-99'
								}}
							>
								<FuseLayout layouts={themeLayouts} />
							</SnackbarProvider>
						</FuseAuthorization>
					</BrowserRouter>
				</AuthProvider>
			</FuseTheme>
		</CacheProvider>
	);
}

export default withAppProviders(App);
